import { render } from "./test_payment_banner.vue?vue&type=template&id=68b2a929"
import script from "./test_payment_banner.vue?vue&type=script&lang=js"
export * from "./test_payment_banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__